import { ref } from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import {INews} from "@/models/homepage/INews";

export async function deleteNews(uuid: string) {
    await ApiService.delete("news/" + uuid)
        .then(() => {
            return true;
        })
        .catch(() => {
            swal.error();
            return false;
        });
}

export async function fetchNewsByUuid(uuid: string):Promise<INews> {
    const news: INews = {} as INews;
    try {
        const { data } = await ApiService.get("news/" + uuid, {
            headers: { Accept: "application/ld+json" },
        });
        const apiData = data.data;
        news.uuid = apiData.uuid;
        news.position = apiData.position;
        news.product = apiData.product.uuid;
        news.imageWeb = apiData.imageWeb;
        news.imageMobile = apiData.imageMobile;
    } catch (error) {
        swal.error();
    }

    return news;
}

export async function fetchNews(
    itemsPerPage: number,
    page: number,
    criteria?: string,
    sort?: {
        fieldLabel: string;
        fieldValue: string;
    }
) {
    const isLoading = ref<boolean>(true);
    const totalRecords = ref<number>(0);
    const news = Array<INews>();
    const tableData = ref<Array<INews>>(news);
    let params = {
        itemsPerPage: itemsPerPage,
        page: page,
        search: criteria,
        archived: false,
    };

    if (criteria !== "") {
        params = { ...params, search: criteria };
    }

    if (sort !== undefined) {
        const { fieldValue, fieldLabel } = sort;
        params = {
            ...params,
            [fieldLabel]: fieldValue,
            ["archived"]: false,
        };
    }

    try {
        const { data } = await ApiService.get("news", {
            params: params,
            headers: { Accept: "application/ld+json" },
        });
        totalRecords.value = data.data["hydra:totalItems"];
        data.data["hydra:member"].forEach((item) => {
            item.uuid = item.uuid;
            item.position = item.position;
            item.imageWeb = item.imageWeb;
            tableData.value.push(item);
        });
    } catch (error) {
        swal.error();
    }
    isLoading.value = false;
    return [isLoading, totalRecords, tableData];
}

export async function updateNews(uuid: string, data: any): Promise<any> {
    await ApiService.put("news/" + uuid, data)
        .then(() => {
            return true;
        })
        .catch(() => {
            swal.error();
        });
    return data;
}